import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FieldDefinitionInfo } from './FieldDefinitionInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type VisibleCardFields_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', fieldsCard?: { __typename?: 'ShareFieldConnection', nodes: Array<{ __typename?: 'ShareField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleCardFields_Collection_Fragment = { __typename?: 'Collection', fieldsCard?: { __typename?: 'CollectionFieldConnection', nodes: Array<{ __typename?: 'CollectionField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleCardFields_CollectionShare_Fragment = { __typename?: 'CollectionShare', fieldsCard?: { __typename?: 'ShareFieldConnection', nodes: Array<{ __typename?: 'ShareField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleCardFieldsFragment = VisibleCardFields_AdHocAssetsShare_Fragment | VisibleCardFields_Collection_Fragment | VisibleCardFields_CollectionShare_Fragment;

export const VisibleCardFields = /*#__PURE__*/ gql`
    fragment VisibleCardFields on AssetAggregate {
  fieldsCard(page: {first: 100}) {
    nodes {
      isVisible
      fieldDefinition {
        ...FieldDefinitionInfo
      }
    }
  }
}
    ${FieldDefinitionInfo}` as unknown as DocumentNode<VisibleCardFieldsFragment, unknown>;

        

        
export const useVisibleCardFieldsFragment = (
  input: string | Omit<UseFragmentOptions<VisibleCardFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<VisibleCardFieldsFragment>({
    fragment: VisibleCardFields,
    fragmentName: 'VisibleCardFields',
    ...options,
  });
};
  
        